import React from "react";
import { Tabs, Spin, Icon } from "antd";
import TrackedWebsitesTabItem from "../TrackedWebsitesTabItem/TrackedWebsitesTabItem";
import AddNewTrackedWebsite from "../AddNewTrackedWebsite/AddNewTrackedWebsite";
import DefaultLayout from "../../../Dashboard/DefaultLayout";
import PropTypes from "prop-types";
import "./TrackedWebsitesTabs.less";

const { TabPane } = Tabs;

const TrackedWebsitesTabs = props => {
  return (
    <div className="tracked-websites-tabs">
      {props.isLoading && <Spin indicator={<Icon data-cy="loader" type="loading" style={{ fontSize: 18 }} spin />} />}
      {!props.isLoading && props.trackedWebsites.length === 0 ? <DefaultLayout push={props.push} /> : null}
      {!props.isLoading && props.trackedWebsites.length ? (
        <Tabs
          className="dashboard-tabs"
          animated={false}
          destroyInactiveTabPane={props.destroyInactiveTabs}
          activeKey={props.activeTabKey}
          onChange={props.onTabChange}
          tabBarExtraContent={
            props.showAddNewWebsite ? (
              <AddNewTrackedWebsite
                onAddTrackedWebsite={props.onAddTrackedWebsite}
                isAddingTrackedWebsite={props.isAddingTrackedWebsite}
                isAddingTrackedKeywords={props.isAddingTrackedKeywords}
              />
            ) : null
          }>
          {props.trackedWebsites.map(website => {
            return (
              <TabPane
                tab={
                  <TrackedWebsitesTabItem
                    push={props.push}
                    status={props.showStatus ? "passed" : null}
                    url={props.showDomains ? website["domain"] : website["url"]}
                    faviconUrl={props.faviconsUrls[website["url"]]}
                  />
                }
                key={website["guid"]}>
                {props.tabContent}
              </TabPane>
            );
          })}
        </Tabs>
      ) : null}
    </div>
  );
};

TrackedWebsitesTabs.defaultProps = {
  isLoading: false,
  trackedWebsites: [],
  tabContent: null,
  activeTabKey: "",
  onTabChange: null,
  showStatus: false,
  showAddNewWebsite: false,
  showDomains: false,
  onAddTrackedWebsite: null,
  isAddingTrackedWebsite: false
};

TrackedWebsitesTabs.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  trackedWebsites: PropTypes.arrayOf(PropTypes.object).isRequired,
  tabContent: PropTypes.object.isRequired,
  activeTabKey: PropTypes.string,
  onTabChange: PropTypes.func.isRequired,
  showStatus: PropTypes.bool,
  showAddNewWebsite: PropTypes.bool,
  showDomains: PropTypes.bool,
  onAddTrackedWebsite: PropTypes.func,
  isAddingTrackedWebsite: PropTypes.bool
};

export default TrackedWebsitesTabs;
